var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserFocus = function SvgIconUserFocus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 2.75a1 1 0 1 0 0 2h2.375v2.375a1 1 0 1 0 2 0V4.5a1.75 1.75 0 0 0-1.75-1.75zM21.25 16.875a1 1 0 1 0-2 0v2.375h-2.375a1 1 0 1 0 0 2H19.5a1.75 1.75 0 0 0 1.75-1.75zM3.75 15.875a1 1 0 0 1 1 1v2.375h2.375a1 1 0 1 1 0 2H4.5a1.75 1.75 0 0 1-1.75-1.75v-2.625a1 1 0 0 1 1-1M4.5 2.75A1.75 1.75 0 0 0 2.75 4.5v2.625a1 1 0 0 0 2 0V4.75h2.375a1 1 0 0 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.955 13.196a4 4 0 1 0-5.91 0q-.004 0-.008.003A6.6 6.6 0 0 0 6.7 15.15a1 1 0 0 0 1.6 1.2 4.625 4.625 0 0 1 7.4 0 1 1 0 0 0 1.6-1.2 6.6 6.6 0 0 0-2.337-1.95zM12 8.5a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
    clipRule: "evenodd"
  }))));
};
export default SvgIconUserFocus;